import styled from "styled-components";

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.hasError ? props.theme.colors.errorDark : props.theme.colors.black};
  border-radius: 8px;
  height: 40px;
  padding: 6px 8px;
  transition: all 0.2s ease-in-out;
`;

const InputField = styled.input`
  border: none;
  outline: none;
  background: transparent;
  font-family: ${props => props.theme.fonts.family.inter};
  font-size: 14px;
  color: ${props => props.theme.colors.greyEleven};
  width: 200px;
  padding: 4px 8px;

  &::placeholder {
    color: ${props => props.theme.colors.greyEleven};
  }
`;

const SearchIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.isExpanded ? 'transparent' : props.theme.colors.clearGray};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  ${props => !props.isExpanded && 'padding: 6px 8px;'}

  svg {
    width: 24px;
    height: auto;
    color: ${props => props.isExpanded ? props.theme.colors.darkGray : props.theme.colors.clearGray};
  }
`;

const ClearIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  cursor: pointer;
  transition: color 0.3s ease;
`;

const SearchResults = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: ${props => props.theme.colors.davysGrey};
  white-space: nowrap;
  min-width: 70px;
`;

const ExpandIconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ExpandIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: ${props => props.theme.colors.primaryWhite};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-radius: 8px;

  &:hover {
    background-color: ${props => props.theme.colors.silverGrayTwo};
  }

  svg {
    width: 16px;
    height: auto;
    color: ${props => props.theme.colors.greyEleven};
  }
`;

const CancelText = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.davysGrey};
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const LoadingIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 70px;

  svg {
    color: ${props => props.theme.colors.activeBlue};
  }
`;


export {
  SearchContainer,
  InputWrapper,
  InputField,
  SearchIcon,
  ClearIcon,
  SearchResults,
  ExpandIconsContainer,
  ExpandIconWrapper,
  CancelText,
  LoadingIndicator,
}; 